import GeneralSettings from './GeneralSettings';

export default {
  title: 'POS General Settings',
  description: 'Here you can configure the general settings of POS.',
  path: '/pos-settings/general-settings',
  component: GeneralSettings,
  rootPath: { name: 'POS Settings', uri: '/pos-settings' },
  subPath: [{ name: 'General Settings' }],
};
